export const appConstants = {
    SELECT_DATE_RANGE: "SELECT_DATE_RANGE",
    TOTAL_NO_ROOM: "TOTAL_NO_ROOM",
    TOTAL_NO_GUEST: "TOTAL_NO_GUEST",
    SEARCH_CITY_NAME: "SEARCH_CITY_NAME",
};